import { api } from '../api';
import { REMOVE_PUSH_TOKEN, USER_PUSH_TOKEN } from '@/constants/pushMessages';
import {
  RegisterPushTokenRequest,
  RemovePushTokenRequest
} from '@/services/pushMessages/types';

export const pushMessagesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    registerPushToken: builder.mutation<void, RegisterPushTokenRequest>({
      query: (body) => ({
        url: USER_PUSH_TOKEN,
        method: 'POST',
        body
      })
    }),
    removePushToken: builder.mutation<void, RemovePushTokenRequest>({
      query: (body) => ({
        url: REMOVE_PUSH_TOKEN,
        method: 'POST',
        body
      })
    })
  })
});

export const { useRegisterPushTokenMutation, useRemovePushTokenMutation } =
  pushMessagesApi;
